import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Register from "@/pages/register/page";
import Login from "@/pages/login/page";
import ForgotPassword from "@/pages/forgot-password/page";
import ResetPassword from "@/pages/reset-password/page";
import Payment from "@/pages/payment/page";
import ParticipantDashboard from "@/pages/dashboard/participant/page";
import OrganizerDashboard from "@/pages/dashboard/organizer/page";
import OrganizerTeams from "@/pages/dashboard/organizer/teams/page";
import OrganizerProblemStatements from "@/pages/dashboard/organizer/problem-statements/page";
import OrganizerAnnouncements from "@/pages/dashboard/organizer/announcements/page";
import OrganizerDomains from "@/pages/dashboard/organizer/domains/page";
import OrganizerReports from "@/pages/dashboard/organizer/reports/page";
import ProblemStatements from "@/pages/problem-statements/page";
import AdminDashboard from "@/pages/dashboard/admin/page";
import AdminSettings from "@/pages/dashboard/admin/settings/page";
import AdminTeams from "@/pages/dashboard/admin/teams/page";
import AdminParticipants from "@/pages/dashboard/admin/participants/page";
import AdminFaculty from "@/pages/dashboard/admin/faculty/page";
import AdminProblemStatements from "@/pages/dashboard/admin/problem-statements/page";
import AdminPayments from "@/pages/dashboard/admin/payments/page";
import AdminAnnouncements from "@/pages/dashboard/admin/announcements/page";
import AdminReports from "@/pages/dashboard/admin/reports/page";
import AdminUsers from "@/pages/dashboard/admin/users/page";
import AdminAuditLogs from "@/pages/dashboard/admin/audit-logs/page";
import AdminDomains from "@/pages/dashboard/admin/domains/page";
import AdminSponsors from "@/pages/dashboard/admin/sponsors/page";
import AdminSponsorCategories from "@/pages/dashboard/admin/sponsors/categories/page";
import AccountsDashboard from "@/pages/dashboard/accounts/page";
import OrganizerSponsors from "@/pages/dashboard/organizer/sponsors/page";
import OrganizerPayments from "@/pages/dashboard/organizer/payments/page";
import DomainProblems from "@/pages/problem-statements/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/dashboard/participant",
    element: <ParticipantDashboard />,
  },
  {
    path: "/dashboard/organizer",
    element: <OrganizerDashboard />,
  },
  {
    path: "/dashboard/organizer/teams",
    element: <OrganizerTeams />,
  },
  {
    path: "/dashboard/organizer/problem-statements",
    element: <OrganizerProblemStatements />,
  },
  {
    path: "/dashboard/organizer/announcements",
    element: <OrganizerAnnouncements />,
  },
  {
    path: "/dashboard/organizer/domains",
    element: <OrganizerDomains />,
  },
  {
    path: "/dashboard/organizer/reports",
    element: <OrganizerReports />,
  },
  {
    path: "/problem-statements",
    element: <ProblemStatements />,
  },
  {
    path: "/dashboard/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/dashboard/admin/settings",
    element: <AdminSettings />,
  },
  {
    path: "/dashboard/admin/teams",
    element: <AdminTeams />,
  },
  {
    path: "/dashboard/admin/participants",
    element: <AdminParticipants />,
  },
  {
    path: "/dashboard/admin/faculty",
    element: <AdminFaculty />,
  },
  {
    path: "/dashboard/admin/problem-statements",
    element: <AdminProblemStatements />,
  },
  {
    path: "/dashboard/admin/domains",
    element: <AdminDomains />,
  },
  {
    path: "/dashboard/admin/sponsors",
    element: <AdminSponsors />,
  },
  {
    path: "/dashboard/admin/sponsors/categories",
    element: <AdminSponsorCategories />,
  },
  {
    path: "/dashboard/admin/payments",
    element: <AdminPayments />,
  },
  {
    path: "/dashboard/admin/announcements",
    element: <AdminAnnouncements />,
  },
  {
    path: "/dashboard/admin/reports",
    element: <AdminReports />,
  },
  {
    path: "/dashboard/admin/users",
    element: <AdminUsers />,
  },
  {
    path: "/dashboard/admin/audit-logs",
    element: <AdminAuditLogs />,
  },
  {
    path: "/dashboard/accounts",
    element: <AccountsDashboard />,
  },
  {
    path: "/dashboard/organizer/sponsors",
    element: <OrganizerSponsors />,
  },
  {
    path: "/dashboard/organizer/payments",
    element: <OrganizerPayments />,
  },
  {
    path: "/problem-statements/:domainId",
    element: <DomainProblems />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;